import { StoreContext } from "@metablock/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import Main from "./Main";
import render from "./render";
import { createStores } from "./stores";
import { lightTheme } from "./theme";

render(
  <BrowserRouter>
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <StoreContext.Provider value={createStores()}>
        <Main />
      </StoreContext.Provider>
    </ThemeProvider>
  </BrowserRouter>
);
